import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/css/main.scss';
import './assets/css/treeView.scss';
import './assets/css/radio.scss';
import './assets/css/loading.scss';

import { ThemeProvider, Toaster } from './components';
import { LoadingProvider } from './components/ui/loading';
import { ConfirmProvider, ImagePreviewProvider, LoadingOverlayProvider } from './hooks';
import reportWebVitals from './reportWebVitals';
import StoreProvider from './store/provider';
import './i18n';

const root = createRoot(document.getElementById('webgl') as HTMLElement);

root.render(
  <LoadingProvider>
    <LoadingOverlayProvider>
      <ThemeProvider>
        <StoreProvider>
          <ConfirmProvider>
            <ImagePreviewProvider>
              <App />
            </ImagePreviewProvider>
          </ConfirmProvider>
        </StoreProvider>
        <Toaster />
      </ThemeProvider>
    </LoadingOverlayProvider>
  </LoadingProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
